import he from 'he';
import * as React from 'react';
import { Head } from 'react-static';
import { SITE_TITLE } from '../../common/constants';
import { HeadTitleProps } from './HeadTitle.props';

function decodeSpecificHtmlEntities(str: string): string {
  return str
    .replace(/&#x27;/g, '’')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/(^|[\s\(\[{<])"([^"]+)"(?=[\s\)\]}>,.!?;:]|$)/g, '$1“$2”')
    .replace(/(^|[\s\(\[{<])'([^']+)'(?=[\s\)\]}>,.!?;:]|$)/g, '$1‘$2’')
    .replace(/(\w)'(\w)/g, '$1’$2');
}

function decodeHtmlEntities(html: string): string {
  if (!html) return '';

  try {
    // If running in browser — use DOMParser for better performance
    if (typeof window !== 'undefined' && typeof DOMParser !== 'undefined') {
      const parser = new DOMParser();
      const decoded = parser.parseFromString(html, 'text/html').documentElement.textContent;
      return decodeSpecificHtmlEntities(decoded || '') || decodeSpecificHtmlEntities(html);
    }
  } catch {
    // ignore and fall back
  }

  // Fallback for SSR/Node or parsing errors
  return he.decode(html);
}

export const HeadTitle = ({ title }: HeadTitleProps) => {
  let fullTitle: string = decodeHtmlEntities(SITE_TITLE);

  if (title) {
    const cleanTitle = decodeHtmlEntities(title);
    fullTitle = `${fullTitle} | ${cleanTitle}`;
  }

  return (
    <Head>
      <title>{fullTitle}</title>
      <meta property='og:title' content={fullTitle} />
    </Head>
  );
  /*let fullTitle: string = SITE_TITLE;

  if (title) {
    fullTitle = `${fullTitle} | ${title}`;
  }

  return (
    <Head>
      <title>{fullTitle}</title>
      <meta property='og:title' content={fullTitle} />
    </Head>
  );*/
};
